import { getDroplink, getCheckbox } from 'src/shared/param-utils';
import { useConditionalRendering } from 'src/shared/useConditionalRendering';
import { ReverseRowProps } from '@ahc-digital/component-library';
import { C11ReverseRowStoryWithVisualProps } from './C11ReverseRowStoryWithVisual.types';

export function CreateReverseRowStoryWithVisualModel(
  props?: C11ReverseRowStoryWithVisualProps
): ReverseRowProps {
  type t = ReverseRowProps;
  const { params, fields } = props || {};
  const { renderText, renderRichText, renderLink, renderImage } = useConditionalRendering();

  return {
    headline: renderText(fields?.Headline, { required: true }),
    firstCta: renderLink(fields?.FirstCTA),
    secondCta: renderLink(fields?.SecondCTA),
    ctaStyle: getDroplink<t['ctaStyle']>(params?.CTAStyle, 'button'),
    mediaSide: getDroplink<t['mediaSide']>(params?.ImageSide, 'left'),
    headlineTag: getDroplink<t['headlineTag']>(params?.HeadlineTag, 'p'),
    supportCopy: renderRichText(fields?.SupportCopy),
    image: renderImage(fields?.Image),
    contentAlignment: getDroplink<t['contentAlignment']>(params?.ContentVerticalAlignment, 'top'),
    videoId: fields?.VideoID?.value || '',
    shouldLazyLoad: getCheckbox(params?.ShouldLazyLoad),
  };
}
